<template>
  <div>
    <el-button type="primary" size="small" @click="handleEdit()" v-code="81102">
      添加订单
    </el-button>
    <el-table :data="list">
      <el-table-column label="单号" align="center" prop="number">
      </el-table-column>
      <el-table-column label="销售" align="center" prop="saler">
      </el-table-column>
      <el-table-column label="客户" align="center" prop="customer_name">
      </el-table-column>
      <el-table-column label="客户联系人" align="center">
        <template slot-scope="scope">
          {{ scope.row.customer_contact
          }}{{
            scope.row.customer_contact_phone
              ? '（' + scope.row.customer_contact_phone + '）'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column label="销售钻头" align="center">
        <template slot-scope="scope">
          <div v-for="item in scope.row.drill_ids" :key="item">
            <DrillLink :no="item">{{ item }}</DrillLink>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订单金额" align="center" prop="total_price">
        <template slot-scope="scope">{{
          scope.row.total_price.toFixed(2)
        }}</template>
      </el-table-column>
      <el-table-column label="创建日期" align="center">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" type="primary">{{
            SaleOrderStatusMap[scope.row.status]
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <el-popconfirm
            v-code="81104"
            v-if="scope.row.status == 1"
            title="确认删除该订单吗？"
            @confirm="handleDelete(scope.row.id, scope.$index)"
          >
            <el-link :underline="false" slot="reference" type="danger"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            v-code="81103"
            :underline="false"
            v-if="scope.row.status == 1"
            class="ml-10"
            type="primary"
            @click="handleEdit(scope.row, scope.$index)"
            >编辑</el-link
          >
          <el-link
            v-code="81105"
            :underline="false"
            class="ml-10"
            plain
            type="primary"
            @click="$router.push(`${$route.path}/${scope.row.id}`)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <editor
      :model="model"
      :show.sync="formerVisible"
      @callback="callback"
    ></editor>
  </div>
</template>

<script>
import { saleOrderDelete } from '@/service/getData'
import { SaleOrderStatusMap } from '../../../config/global'
import editor from './editor'
export default {
  components: {
    editor,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      SaleOrderStatusMap,
      formerVisible: false,
      editIndex: -1,
      model: {},
    }
  },
  methods: {
    handleEdit(item, index) {
      if (!item) {
        this.editIndex = -1
        this.model = {
          number: '',
          saler: '',
          customer_name: '',
          customer_contact: '',
          customer_contact_phone: '',
          total_price: 0,
          drill_ids: [],
          remark: '',
        }
      } else {
        this.model = this.clone(item)
        this.editIndex = index
      }
      this.formerVisible = true
    },
    async handleDelete(id, index) {
      let res = await saleOrderDelete(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },

    callback(data) {
      if (this.editIndex == -1) {
        this.list.unshift(data)
      } else {
        this.$set(this.list, this.editIndex, data)
      }
    },
  },
}
</script>